export enum RxntIcon {
  None,
  Refresh,
  Print,
  Export,
  Add,
  Edit,
  Close,
  Menu,
  FirstPage,
  PrevPage,
  NextPage,
  LastPage,
  Custom,
  ChevronDown,
  Pdf,
  Lock,
  Unlock,
  Import,
  ShowPassword,
  HidePassword,
}
